import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba749f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PrintProductPriceTag = _resolveComponent("PrintProductPriceTag")!
  const _component_ProductDeleteModal = _resolveComponent("ProductDeleteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      color: "white",
      type: "a",
      href: _ctx.productLink,
      target: "_blank"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Endre")
      ]),
      _: 1
    }, 8, ["href"]),
    (_ctx.showPrintButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printPriceTagOpen = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Skriv ut prislapp")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.canDelete)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          color: "red",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteOpen = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Slett")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showPrintButton)
      ? (_openBlock(), _createBlock(_component_PrintProductPriceTag, {
          key: 2,
          onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPriceTagOpen = false)),
          product: _ctx.product,
          open: _ctx.printPriceTagOpen
        }, null, 8, ["product", "open"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProductDeleteModal, {
      onDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteOpen = false)),
      open: _ctx.deleteOpen,
      product: _ctx.product
    }, null, 8, ["open", "product"])
  ]))
}